// src/layouts/AuthLayout/AuthLayout.jsx
import React from 'react';

function AuthLayout({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      {children}
    </div>
  );
}

export default AuthLayout;